// extracted by mini-css-extract-plugin
module.exports =  {"pageCardLoaderContainer":"pageCardLoaderContainer_KFNvH37V","appWidget":"appWidget_k0Clyuu3"};